// Funzione per inizializzare/riattaccare gli elementi
function initializeSamplesElements() {
    // Riprendi i riferimenti agli elementi ogni volta
    const samplesOverlay = document.querySelector('.samples__overlay');
    const samplesErrorDialog = document.querySelector('[data-campioncini-message]');
    const samplesDialog = document.querySelector(".samples-dialog");
    const samplesDialogCloseButton = document.querySelector("[js-close-samples]");
    const samplesErrorCloseButton = document.querySelector("[js-close-error]");
    
    return {
        samplesOverlay,
        samplesErrorDialog,
        samplesDialog,
        samplesDialogCloseButton,
        samplesErrorCloseButton
    };
}

async function openCampionciniModal() {
    const { samplesDialog, samplesOverlay } = initializeSamplesElements();
    
    if (samplesDialog && samplesOverlay) {
        samplesDialog.classList.add('is-open');
        samplesDialog.setAttribute('aria-hidden', 'false');
        samplesOverlay.style.display = 'block';
        samplesOverlay.setAttribute('aria-hidden', 'false');

        // Focus management per accessibilità
        const firstFocusableElement = samplesDialog.querySelector('input, button, [tabindex]:not([tabindex="-1"])');
        if (firstFocusableElement) {
            firstFocusableElement.focus();
        }
    }
}

function closeCampionciniModal() {
    const { samplesDialog, samplesOverlay } = initializeSamplesElements();
    
    if (samplesDialog && samplesOverlay) {
        samplesDialog.classList.remove('is-open');
        samplesDialog.setAttribute('aria-hidden', 'true');
        samplesOverlay.style.display = 'none';
        samplesOverlay.setAttribute('aria-hidden', 'true');
    }
}

function closeErrorModal() {
    const { samplesErrorDialog } = initializeSamplesElements();
    
    if (samplesErrorDialog) {
        samplesErrorDialog.classList.remove('is-open');
        samplesErrorDialog.setAttribute('aria-hidden', 'true');
    }
}

// Event delegation - funziona sempre perché è attaccato al document
document.addEventListener('click', function(e) {
    // Controlla se l'elemento è il button samples o un suo figlio diretto
    const samplesButton = e.target.closest('[data-open-samples]');
    
    if (samplesButton) {
        // Escludi i click su link e altri elementi interattivi dentro il button
        if (e.target.tagName === 'A' || e.target.closest('a')) {
            return; // Non gestire click su link
        }
        
        // Gestisci solo click su span, svg, icon o il button stesso
        if (e.target.matches('[data-open-samples]') || 
            e.target.matches('[data-open-samples] span') ||
            e.target.matches('[data-open-samples] svg') ||
            e.target.matches('[data-open-samples] .icon')) {
            
            e.preventDefault();
            e.stopPropagation();
            openCampionciniModal();
        }
    }
    
    // Close buttons
    if (e.target.matches('[js-close-samples]')) {
        closeCampionciniModal();
    }
    
    if (e.target.matches('[js-close-error]')) {
        closeErrorModal();
    }
});

// Chiudi dialog con ESC
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const { samplesDialog, samplesErrorDialog } = initializeSamplesElements();
        
        if (samplesDialog && samplesDialog.classList.contains('is-open')) {
            closeCampionciniModal();
        }
        if (samplesErrorDialog && samplesErrorDialog.classList.contains('is-open')) {
            closeErrorModal();
        }
    }
});

// Chiudi cliccando sull'overlay - usa event delegation
document.addEventListener('click', (e) => {
    if (e.target.matches('.samples__overlay')) {
        closeCampionciniModal();
    }
});

// Inizializza aria-hidden al caricamento e dopo aggiornamenti
function initializeAriaHidden() {
    const { samplesDialog, samplesErrorDialog, samplesOverlay } = initializeSamplesElements();
    
    if (samplesDialog) samplesDialog.setAttribute('aria-hidden', 'true');
    if (samplesErrorDialog) samplesErrorDialog.setAttribute('aria-hidden', 'true');
    if (samplesOverlay) samplesOverlay.setAttribute('aria-hidden', 'true');
}

document.addEventListener('DOMContentLoaded', initializeAriaHidden);

// Esponi la funzione globalmente per debug
window.openCampionciniModal = openCampionciniModal;